import {REPORT_ALL_FRONTLINE_ORDERS} from '/enum/records.enum';

export default {
  reportName: REPORT_ALL_FRONTLINE_ORDERS,
};
